export type EventLog = {
  type: EventLogType
  updaterEmail: string
  updaterAuthModel: AuthModel
  userEmail: string
  data: Record<string, unknown>
  createdAt: Date
}

type SmartMeterConfiguration = {
  monthlyBilling?: boolean
  dynamicTariff?: boolean
}

export type MeteringUpdateEventLog = EventLog & {
  data: {
    serviceContractId: string
    newMeteringConfiguration: SmartMeterConfiguration
    oldMeteringConfiguration: SmartMeterConfiguration
    eventDueDate: string
  }
}

// ENUMS

export enum EventLogType {
  ACCOUNT_UPDATED = 'accountUpdated',
  BILLING_CONTRACT_UPDATED = 'billingContractUpdated',
  BILLING_CYCLE_VIEWED = 'billingCycleViewed',
  CONTACT_UPDATED = 'contactUpdated',
  CONTRACT_TERMINATED = 'contractTerminated',
  CREATE_CONTRACT = 'createContract',
  METER_CONFIG_UPDATED = 'meterConfigUpdated',
  METER_READINGS_ADDED = 'meterReadingsAdded',
  OPPORTUNITY_UPDATED = 'opportunityUpdated',
  PORTAL_INSTALMENT_UPDATED = 'portalInstalmentUpdated',
  SERVICE_CONTRACT_UPDATED = 'serviceContractUpdated',
  SURVEY_CLOSED = 'surveyClosed',
  SURVEY_RESPONDED = 'surveyResponded',

  // DEPRECATED - Not used anymore but kept for backwards compatibility
  EXTRA_ADDRESS_CREATED = 'extraAddressCreated',
  PORTAL_BILLING_UPDATED = 'portalBillingUpdated', // Renamed to BILLING_CONTRACT_UPDATED
  PORTAL_CUSTOMER_UPDATED = 'portalCustomerUpdated',
  PORTAL_SETTLEMENT_REQUESTED = 'portalSettlementRequested'
}

export enum AuthModel {
  INTERNAL = 'internalUsers',
  SALES = 'salesUsers',
  USER = 'users'
}
